import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import {translation_en} from "./en";
import {translation_ja} from "./ja";
import {is_dev} from "../utils/debug";

export const defaultNS = 'translation';

export const resources = {
    en: {
        translation: translation_en
    },
    ja: {
        translation: translation_ja
    }
} as const;

i18n.use(initReactI18next).init({
    lng: 'ja',
    fallbackLng: 'ja',
    debug: is_dev(),
    interpolation: {
        escapeValue: false
    },
    resources,
});
